import {loadLibrary} from "./Util";
import {LIB_URL} from '../App';

function renderHealthTable(rootDom) {
    const $root = $(rootDom);
    const mql = window.matchMedia('(max-width: 767px)');
    const $toggler = $(rootDom).next('.js-wwdo-health-table-toggle');
    let swiper;

    mql.addEventListener('change', matchMediaHandler);

    function matchMediaHandler() {
        if (mql.matches) {
            loadLibrary(LIB_URL.SWIPER, function () {
                swiper = new Swiper($('.swiper-container', rootDom)[0], {
                    loop: true,
                    slidesPerView: 1,
                    autoHeight: true,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true
                    }
                });
            });
        } else {
            swiper && swiper.destroy();
        }
    }

    $toggler.on('click', function () {
        $root.toggleClass('_closed');
    });

    matchMediaHandler();
}

document.querySelectorAll('.js-wwdo-health-table').forEach(renderHealthTable);
